import { create } from "zustand"
import { subscribeWithSelector } from "zustand/middleware"

export default create(subscribeWithSelector((set) =>
{
    return {

        touch: 'false',
        play: false,
        animFinished: false,
        infoPanel: 'null',

        reset: ()=>
            {
                set((state)=>
                {
                    {
                        var pan1 = document.getElementById('p1')
                        var pan2 = document.getElementById('p2')
                        var pan3 = document.getElementById('p3')
                        var pan4 = document.getElementById('p4')
                        var pan5 = document.getElementById('p5')
                        var pan6 = document.getElementById('p6')
                        var pan7 = document.getElementById('p7')

                        if (pan1.classList.contains('show'))
                            {
                                pan1.classList.add('hide')
                            }
                        pan1.classList.remove('show')
                        
                        if(pan2.classList.contains('show'))
                            {
                                pan2.classList.add('hide')
                            }
                        pan2.classList.remove('show')

                        if (pan3.classList.contains('show'))
                            {
                                pan3.classList.add('hide')
                            }
                        pan3.classList.remove('show')
                        
                        if(pan4.classList.contains('show'))
                            {
                                pan4.classList.add('hide')
                            }
                        pan4.classList.remove('show')

                        if (pan5.classList.contains('show'))
                            {
                                pan5.classList.add('hide')
                            }
                        pan5.classList.remove('show')
                        
                        if(pan6.classList.contains('show'))
                            {
                                pan6.classList.add('hide')
                            }
                        pan6.classList.remove('show')

                        if(pan7.classList.contains('show'))
                            {
                                pan7.classList.add('hide')
                            }
                        pan7.classList.remove('show')
                    
                    return { infoPanel: 'null' }
                    }
                })
                
            },

        toggleAnim: ()=>
            {
                set((state)=>
                {
                    if(state.animFinished === false)
                        {
                            
                            return { animFinished: true }
                            
                        }

                    if(state.animFinished === true)
                        {
                            
                            return { animFinished: false }
                            
                        }
                        
                        
                    return {}
                })
            },


        toggleGas: ()=>
            {
                set((state)=>
                {
                    if(state.play === false)
                        {
                            
                            return { play: true }
                            
                        }

                    if(state.play === true)
                        {
                            
                            return { play: false }
                            
                        }
                        
                        
                    return {}
                })
            },

        touched: ()=>
            {
                set((state)=>
                {   
                    
                        {
    
                            return { touch: 'true' }       
                        }
                              
    
                    
                })
            },

        p1: ()=>
            {
                set((state)=>
                {
                    {
                        var pan1 = document.getElementById('p1')
                        pan1.classList.remove('hide')
                        pan1.classList.add('show')
    
                        return { infoPanel: '1' }
                    }
                })
                
            },

        p2: ()=>
            {
                set((state)=>
                {
                    {
                        var pan1 = document.getElementById('p2')
                        pan1.classList.remove('hide')
                        pan1.classList.add('show')
    
                        return { infoPanel: '2' }
                    }
                })
                
            },

        p3: ()=>
            {
                set((state)=>
                {
                    {
                        var pan1 = document.getElementById('p3')
                        pan1.classList.remove('hide')
                        pan1.classList.add('show')
    
                        return { infoPanel: '3' }
                    }
                })
                
            },

        p4: ()=>
            {
                set((state)=>
                {
                    {
                        var pan1 = document.getElementById('p4')
                        pan1.classList.remove('hide')
                        pan1.classList.add('show')
    
                        return { infoPanel: '4' }
                    }
                })
                
            },

        p5: ()=>
            {
                set((state)=>
                {
                    {
                        var pan1 = document.getElementById('p5')
                        pan1.classList.remove('hide')
                        pan1.classList.add('show')
    
                        return { infoPanel: '5' }
                    }
                })
                
            },

        p6: ()=>
            {
                set((state)=>
                {
                    {
                        var pan1 = document.getElementById('p6')
                        pan1.classList.remove('hide')
                        pan1.classList.add('show')
    
                        return { infoPanel: '6' }
                    }
                })
                
            },

        p7: ()=>
            {
                set((state)=>
                {
                    {
                        var pan1 = document.getElementById('p7')
                        pan1.classList.remove('hide')
                        pan1.classList.add('show')
    
                        return { infoPanel: '7' }
                    }
                })
                
            },
    }
}))